// extracted by mini-css-extract-plugin
module.exports = {"prose":"TermsOfService_prose__OQGmc"};